import { AppRouterService } from '../app-router.service';
import { UserContextService } from './../user-context.service';
import { Injectable, inject } from '@angular/core';

@Injectable()
export class ErrorHandlerService {
    private router = inject(AppRouterService);
    private userContextService = inject(UserContextService);


    public handle(response: Response, expectedErrors: string[]): string {
        let error = "";
        if (expectedErrors) {
            expectedErrors.forEach(expectedError => {
                if ((response as any).error.includes(expectedError)) {
                    error = expectedError;
                }
            });
        } else {
            if (response.status == 400) {
            }

            this.handleRestError(response);
        }
        return error;
    }

    private handleRestError(response: Response): void {
        if (response.status === 401) {
            this.userContextService.resetContext();
            this.router.openLogin();
            if (!response.url.includes('refresh') && !response.url.includes('isAuth') && this.userContextService.isAuthorize.value) {
                alert('Http request error 401 UNAUTHORIZED')
            }
        } else if (response.status === 404) {
            // alert('Http request error 404 NOT FOUND');
        } else if (response.status === 403) {
            alert('Access Denied');
        } else if (response.status === 0) {
            alert('Serve offline');
        } else if (response.status === 400) {
        } else if (response.status === 409) {
            alert('Conflict');
        }
        else {
            alert('Unexpected error, error code: ' + response.status);
        }
        
        if (response.status >= 500 && response.status < 600) {
            throw new Error("Internal server error");
        }
        
        const responseError = (response as any).error;
        let errorMessage = "Internal server error";
        
        if (responseError) {
            if (typeof responseError === 'string') {
                errorMessage = responseError;
            } else if (responseError.error) {
                errorMessage = responseError.error;
            } else if (responseError.message) {
                errorMessage = responseError.message;
            } else if (typeof responseError === 'object') {
                errorMessage = JSON.stringify(responseError);
            }
        }
        
        throw new Error(errorMessage);
    }
}
